export let formatNumber = function (num){
    const number = Number(num);
    if (isNaN(number)) {
        throw new Error('请输入有效的数字');
    }
    const [integerPart, decimalPart = '00'] = number.toFixed(2).split('.');
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const formattedDecimal = decimalPart.padEnd(2, '0');
    return `${formattedInteger},${formattedDecimal}`;
}
